import React, {useRef, useLayoutEffect} from 'react';
import type {
  ColorTypes,
  IconType,
  IconSize,
} from '@spaced-out/ui-design-system';

import {Checklist, ChecklistProgressBar} from '@spaced-out/ui-design-system';

import type {ListWidgetPayload, ListWidgetStepStatus} from '../types';


interface ListWidgetProps {
  payload: ListWidgetPayload;
  onStepClick?: (
    stepId: string,
    event: {name: string; payload: Record<string, unknown>},
  ) => void;
  onResize?: () => void;
}

function getIconForStatus(status: ListWidgetStepStatus): {
  iconLeftName: string;
  iconLeftType: IconType;
  iconLeftColor?: ColorTypes;
  iconLeftSize: IconSize;
} {
  const iconObj = {
    iconLeftSize: 'small' as const,
    iconLeftType: 'solid' as const,
  };
  switch (status) {
    case 'completed':
      return {
        ...iconObj,
        iconLeftName: 'check-circle',
        iconLeftColor: 'success',
      };
    default:
      return {
        ...iconObj,
        iconLeftName: 'warning',
      };
  }
}

export function ListWidget({payload, onStepClick, onResize}: ListWidgetProps) {
  const {title, progress, steps} = payload;

  const listItems = steps.map((step) => {
    const icon = getIconForStatus(step.status);
    return {
      ...icon,
      key: step.id,
      label: step.title,
      onExpand: () => {
        if (onStepClick) {
          onStepClick(step.id, step.event);
        }
      },
    };
  });

  const progressBar = (
    <ChecklistProgressBar
      showLoadingBar
      completedItems={
        steps.filter((step) => step.status === 'completed').length
      }
      totalItems={progress.total}
    />
  );

  return (
    <Checklist
      title={title}
      listItems={listItems}
      rightSlot={progressBar}
      isOpen={true}
    />
  );
}
